module.exports = "/_next/static/images/020e972bb2b31e370b294ca3a4bc8e2c-vigilado-left.png";